/* =============================================================================
   ILHA · PÁGINA DE COLEÇÃO NOVA · o botão «Adicionar» (08/10/2026)
   Pedido do Silva: «na página inicial, quando você clica em adicionar, ele marca adicionado. E lá
   dentro da coleção não marca nada... tem que replicar as mesmas coisas dos dois lados.»

   É a mesma regra da inicial (`ilha-c.js`, função `adicionar`), para o cartão do tema:
   ⛔ só diz «Adicionado» quando o carrinho CONFIRMA (evento do tema `product-ajax:added`);
   ⛔ se o tema disser erro, o botão abana e fica como estava, e só o do pedido que falhou.
   ============================================================================= */
(function () {
  'use strict';
  // As duas secções que o chamam podem estar na mesma página: corre uma vez só.
  if (window.__ilhaAdicionado) return;
  window.__ilhaAdicionado = true;
  // Vale na grelha das coleções e na faixa «Produtos que viu recentemente» (que usa o mesmo cartão).
  var FORMULARIO = ':is(.ic-col, recently-viewed-products) form[is="product-form"]';
  var BOTOES = '.product-card__atc, .product-card__list-atc';
  var CERTO = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var pendentes = [];

  function recomecar(el, classe) {
    el.classList.remove(classe);
    void el.offsetWidth;
    el.classList.add(classe);
  }

  // O cartão tem dois botões (o da grelha e o da lista): marcam-se os dois, para a troca de vista não desmentir.
  function botoesDe(formulario) {
    var cartao = formulario.closest('.product-card');
    var lista = Array.prototype.slice.call((cartao || formulario).querySelectorAll(BOTOES));
    return lista.filter(function (b) { return !b.disabled && b.closest('form[is="product-form"]'); });
  }

  function marcar(b) {
    if (!b || b.classList.contains('ic-feito')) return;
    b.classList.add('ic-feito');
    b.setAttribute('aria-label', 'Adicionado ao carrinho');
    var texto = b.querySelector('.product-card__atc-text') || b.querySelector('.btn__text');
    var desenho = b.querySelector('.product-card__atc-icon');
    if (desenho) desenho.innerHTML = CERTO;
    if (texto) {
      if (texto.classList.contains('btn__text')) texto.innerHTML = CERTO + '<span>Adicionado</span>';
      else texto.textContent = 'Adicionado';
    }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches(FORMULARIO)) return;
    var campo = f.querySelector('[name=id]');
    pendentes.push({ id: String(campo ? campo.value : ''), botoes: botoesDe(f), quando: Date.now() });
  }, true);

  document.addEventListener('product-ajax:added', function (e) {
    var d = (e.detail && e.detail.product) || {};
    var ids = [String(d.variant_id || d.id || '')];
    if (Array.isArray(d.items)) d.items.forEach(function (it) { ids.push(String(it.variant_id || it.id)); });
    var resto = [];
    pendentes.forEach(function (p) {
      if (ids.indexOf(p.id) !== -1) p.botoes.forEach(marcar);
      else if (Date.now() - p.quando < 15000) resto.push(p);
    });
    pendentes = resto;
  });

  // O erro só marca o pedido que falhou: o `pubsub` do tema diz qual variante; sem ele, o mais antigo da fila.
  var comPubsub = false;
  function ligarErro() {
    try {
      var ps = window.FoxTheme && window.FoxTheme.pubsub;
      if (comPubsub || !ps || !ps.PUB_SUB_EVENTS || !ps.PUB_SUB_EVENTS.cartError) return;
      ps.subscribe(ps.PUB_SUB_EVENTS.cartError, function (d) {
        var id = String((d && d.productVariantId) || '');
        for (var i = 0; i < pendentes.length; i++) {
          if (pendentes[i].id === id) {
            pendentes[i].botoes.forEach(function (b) { recomecar(b, 'ic-erro'); });
            pendentes.splice(i, 1);
            return;
          }
        }
      });
      comPubsub = true;
    } catch (e) { comPubsub = false; }
  }
  ligarErro();
  document.addEventListener('DOMContentLoaded', ligarErro);
  document.addEventListener('product-ajax:error', function () {
    ligarErro();
    if (comPubsub || !pendentes.length) return;
    pendentes.shift().botoes.forEach(function (b) { recomecar(b, 'ic-erro'); });
  });
})();

/* =============================================================================
   ILHA · «CARREGAR MAIS» SEM SALTOS (12/10/2026) · sim do Silva.
   O vigia mediu o texto do fundo, a paginação e o rodapé das coleções a cair de uma vez (até 0,73 de CLS, 15
   visitas em 48 h). Causa, reproduzida com rede lenta: o «Carregar mais» do tema (`load-more-button`, facets.js)
   vai buscar a página seguinte e ACRESCENTA os produtos por cima do botão; quando a resposta chega depois dos
   500 ms do toque, tudo o que estava à vista por baixo cai, e o Google conta-o (0,54 medido).
   Aqui, no PRÓPRIO toque, reserva-se a altura das linhas que vão chegar (min-height na grelha): o espaço abre-se
   nos 500 ms do toque, que não contam. Quando os produtos entram, a reserva sai e já não mexe nada.
   ⛔ Não toca no facets.js nem no pedido: só lê a grelha e o «X de Y produtos», e mexe numa altura mínima.
   ⛔ A reserva sai SEMPRE: quando os produtos entram, quando a paginação muda sem produtos (resposta vazia), quando
      o pedido falha, quando a grelha é trocada (filtro, ordenação), e no limite ao fim de 15 s.
   ============================================================================= */
(function () {
  'use strict';
  if (window.__ilhaCarregarMais) return;
  window.__ilhaCarregarMais = true;

  function lista() { var c = document.getElementById('ProductGridContainer'); return c && c.querySelector('.products-list'); }

  // «20 de 331 produtos» → [20, 331] (o «vistos» conta também as páginas de antes, mesmo a quem aterrou em ?page=N)
  function vistosEtotal() {
    var p = document.querySelector('#ProductGridContainer .ic-col-vistos');
    var m = p && p.textContent.match(/(\d+)\D+(\d+)/);
    return m ? [parseInt(m[1], 10), parseInt(m[2], 10)] : null;
  }

  // a altura que as linhas que vão chegar vão ocupar, pela média das linhas que já lá estão
  function reservaPara(l, botao) {
    var itens = l.children, n = itens.length;
    if (!n) return 0;
    var topo = itens[0].offsetTop, cols = 0;
    for (var i = 0; i < n && itens[i].offsetTop === topo; i++) cols++;
    if (!cols) return 0;
    var linhas = Math.ceil(n / cols);
    var gap = parseFloat(getComputedStyle(l).rowGap) || 0;
    var porLinha = (l.offsetHeight + gap) / linhas; // linha + o espaço entre linhas
    var pagina = 0;
    try { pagina = parseInt(new URL(botao.getAttribute('action'), location.href).searchParams.get('page'), 10) || 0; } catch (e) {}
    var vt = vistosEtotal();
    var vistos = vt ? vt[0] : n;
    var porPagina = pagina > 1 ? Math.round(vistos / (pagina - 1)) : vistos;
    var vem = vt ? Math.max(0, Math.min(porPagina, vt[1] - vt[0])) : porPagina;
    // as linhas a MAIS que a grelha vai ter (a última linha de agora pode ter lugares vazios)
    return (Math.ceil((n + vem) / cols) - linhas) * porLinha;
  }

  var aEspera = null; // { l, n, obs, relogio }
  function tirar() {
    if (!aEspera) return;
    var e = aEspera, l = e.l;
    aEspera = null;
    e.obs.disconnect();
    clearTimeout(e.relogio);
    // um frame depois de os produtos entrarem: a grelha já tem a altura verdadeira
    requestAnimationFrame(function () {
      l.style.minHeight = ''; l.style.alignContent = ''; document.documentElement.style.overflowAnchor = ''; l.classList.remove('ic-a-carregar');
      levarAosNovos(l, e.n);
    });
  }

  // 17/10/2026 · pedido do Silva: depois do «Carregar mais» a página tem de mostrar os produtos NOVOS. Medido no ar
  // (Widi Care, 1024 px, rede rápida): o Chrome segurava o botão no sítio e o 1.º produto novo ficava 1936 px ACIMA
  // do ecrã; a cliente via o mesmo botão e achava que nada tinha mudado. Agora, quando entram, a página leva-a ao
  // 1.º produto novo (por baixo do cabeçalho). Um scroll não conta para o CLS. Só se mexe se ele estiver fora de vista.
  function levarAosNovos(l, n) {
    if (!l.isConnected) return;
    var novo = l.children[n];
    if (!novo) return;
    var topo = novo.getBoundingClientRect().top;
    var cab = document.querySelector('.header-section');
    var folga = Math.min(cab ? cab.offsetHeight : 0, 180) + 16;
    if (topo >= folga && topo < innerHeight * 0.6) return; // já está à vista
    var reduzir = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, scrollY + topo - folga), behavior: reduzir ? 'auto' : 'smooth' });
  }

  // o pedido do tema falhou (rede, servidor): sai a reserva (o tema deixa o botão em «a carregar», como já fazia)
  if (typeof window.fetch === 'function') {
    var fetchDoTema = window.fetch;
    window.fetch = function (u) {
      var p = fetchDoTema.apply(this, arguments);
      if (aEspera) {
        var url = String((u && u.url) || u || '');
        if (/[?&]page=\d/.test(url)) p.then(function (r) { if (!r.ok) setTimeout(tirar, 0); }, function () { tirar(); });
      }
      return p;
    };
  }

  // em captura: corre ANTES do clique do tema, com a grelha ainda como está
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button[is="load-more-button"]');
    if (!b || b.getAttribute('type') === 'infinite' || b.classList.contains('btn--loading')) return;
    if (aEspera && !aEspera.l.isConnected) tirar(); // a grelha foi trocada (filtro, ordenação) durante a espera
    if (aEspera) return;
    var l = lista();
    if (!l) return;
    var r = reservaPara(l, b);
    if (r <= 0) return;
    // 17/10/2026 · INP: tudo o que se LÊ, lê-se aqui, antes de escrever. Ler a altura DEPOIS de mexer no estilo obrigava
    // o navegador a refazer a grelha inteira dentro do toque, duas vezes (medido a 1280 px: 37 ms com 40 produtos,
    // 136 ms com 120). Lida com a página limpa custa 0 ms, e a grelha refaz-se uma vez só, no desenho seguinte.
    var alto = l.offsetHeight;
    var n = l.children.length;
    // ⚠️ Sem isto o Chrome «ancora» o scroll: ou segura o botão no sítio (e os produtos novos aparecem POR CIMA, fora
    //    de vista), ou salta a página quando eles entram (medido 12/10: 0,89 e 0,91). Desligado só durante a espera,
    //    o espaço abre-se por baixo de onde a cliente está, e os produtos novos aparecem ali, como antes.
    document.documentElement.style.overflowAnchor = 'none';
    l.style.setProperty('--ic-espera-topo', alto + 'px');
    // a grelha com altura mínima ESTICA as linhas que já lá estão para a encher (e encolhia-as quando os produtos chegavam)
    l.style.alignContent = 'start';
    l.style.minHeight = (alto + r) + 'px';
    l.classList.add('ic-a-carregar');
    // a resposta chegou: entram produtos na grelha, ou a paginação muda (o tema escreve-a antes dos produtos, no mesmo
    // passo; uma resposta sem produtos só mexe na paginação). Olha-se só para a grelha e para a paginação.
    var obs = new MutationObserver(function () {
      if (!aEspera) return;
      if (aEspera.l.children.length > aEspera.n) { tirar(); return; }
      setTimeout(function () { if (aEspera && aEspera.obs === obs) tirar(); }, 0);
    });
    obs.observe(l, { childList: true });
    var pag = b.closest('.pagination');
    if (pag) { obs.observe(pag, { childList: true, subtree: true }); if (pag.parentNode) obs.observe(pag.parentNode, { childList: true }); }
    aEspera = { l: l, n: n, obs: obs, relogio: setTimeout(function () { if (aEspera && aEspera.obs === obs) tirar(); }, 15000) };
  }, true);
})();
